<template>
  <v-form v-model="isValid">
    <v-container class="compact">
      <v-card>
        <v-card-text>
          <v-container>
            <h2>{{ formTitle }}</h2>
            <v-row>
              <v-col cols="2" sm="3" md="2">
                <v-text-field v-model="editedItem.kNbr" label="K Nbr" disabled></v-text-field>
              </v-col>
              <v-col cols="2" sm="3" md="2">
                <v-text-field v-model="editedItem.Member.mNbr" label="Owner" :disabled=dis()></v-text-field>
              </v-col>
              <v-col cols="2" sm="3" md="2">
                <v-text-field v-model="editedItem.microchip" :rules="[v => !!v || 'Microchip is required']"
                              label="Microchip"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="2">
                <v-select v-model="editedItem.gender" :items="genders"
                          label="Gender"></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.callName" :rules="[v => !!v || 'Callname is required']"
                              label="Callname"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.registeredName" label="Reg name"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.breed" :rules="[v => !!v || 'Breed is required']"
                              label="Breed"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.xBreeds" label="Cross breeds"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <DateField :rcvd-date="editedItem.dob" :itm-key="dateKey" @datechanged="dob" lbl="D.O.B">
                </DateField>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-checkbox v-model="editedItem.rescue" label="Rescue"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-checkbox v-model="editedItem.deceased" label="Deceased"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-checkbox v-model="editedItem.humanReactive" label="Human reactive"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-checkbox v-model="editedItem.dogReactive" label="Dog reactive"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-checkbox v-model="editedItem.reactiveParking" label="Reactive parking"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-checkbox v-model="editedItem.hasPaid" label="Reg fee paid" :disabled="!isAdmin" v-on:change="syncFeePaid"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="4" md="12">
                <v-textarea
                    auto-grow
                    outlined
                    rows="1"
                    row-height="15"
                    v-model="editedItem.note" label="Notes"></v-textarea>
              </v-col>
            </v-row>
          </v-container>
          <v-container class="titles" v-show="showTitles">
            <h2>Titles:</h2>
            <v-row v-for="title in editedItem.titles" :key="title.id">
              <v-col cols="12" sm="1">{{ title.titleCode }}</v-col>
              <v-col cols="12" sm="3">{{ $itmStore.titles[title.titleCode].titleName }}</v-col>
              <v-col cols="12" sm="2">{{ $iso2AU(title.dateEarned) }}</v-col>
              <v-col cols="12" sm="5">{{ title.comment }}</v-col>
            </v-row>
          </v-container>
          <v-container class="tregs" v-show="showRegs">
            <h2>Trial Registrations:</h2>
            <v-row>
              <v-col cols="12" sm="2">Date</v-col>
              <v-col cols="12" sm="4">Trial</v-col>
              <v-col cols="12" sm="1">Points</v-col>
              <v-col cols="12" sm="1">Faults</v-col>
              <v-col cols="12" sm="1">Place</v-col>
              <v-col cols="12" sm="1">Title</v-col>

            </v-row>
            <v-row v-for='treg in editedItem.registrations' :key="treg.regid">
              <v-col cols="12" sm="2">{{ $iso2AU(treg.startDate) }}</v-col>
              <v-col cols="12" sm="4">{{ treg.trialName }}</v-col>
              <v-col cols="12" sm="1">{{ treg.points/1000 }}</v-col>
              <v-col cols="12" sm="1">{{ treg.faults }}</v-col>
              <v-col cols="12" sm="1">{{ treg.placement }}</v-col>
              <v-col cols="12" sm="1">{{ treg.title }}</v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions v-if="hasRegs">
          <v-btn color="blue darken-1" text @click="toggleR" v-show="!showRegs">Display Trials</v-btn>
          <v-btn color="blue darken-1" text @click="toggleR" v-show="showRegs">Hide Trials</v-btn>
          <v-btn color="blue darken-1" text @click="toggleT" v-show="!showTitles">Display Titles</v-btn>
          <v-btn color="blue darken-1" text @click="toggleT" v-show="showTitles">Hide Titles</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="reset">Reset</v-btn>
          <v-btn color="blue darken-1" text @click="close">Close</v-btn>
          <v-btn color="blue darken-1" text :disabled="!isValid" @click="save">Save</v-btn>
        </v-card-actions>
        <v-card-actions v-if="!hasRegs">
          <v-btn color="blue darken-1" text @click="toggleT" v-show="!showTitles">Display Titles</v-btn>
          <v-btn color="blue darken-1" text @click="toggleT" v-show="showTitles">Hide Titles</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="reset">Reset</v-btn>
          <v-btn color="blue darken-1" text @click="close">Close</v-btn>
          <v-btn color="blue darken-1" text :disabled="!isValid" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-form>
</template>

<script>
import DateField from './DateField'

export default {
  name: "DogEdit",
  components: {
    DateField
  },
  watch: {
    dog(newDog) {
      console.log('watch->newDog')
      console.log(newDog)
      if (newDog) {
        this.savedDog = JSON.stringify(newDog, 3)
        this.editedItem = Object.assign(this.editedItem, this.dog)
        if(this.dog.feePaid == null){
          this.feeIsPaid = false
        } else {
          this.feeIsPaid = true
        }
      } else {
        this.savedDog = ''
        this.editedItem = Object.assign(this.editedItem, this.defaultItem)
      }
      this.editedItem.Member.mNbr = this.mbr.mNbr
    },
  },
  props: {
    mbr: {
      type: Object,
      default: () => {
      }
    },
    dog: {
      type: Object,
      default: () => {
      }
    },
    allowOwnerChange: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showTitles: false,
    showRegs: false,
    feeIsPaid: false,
    // isAdmin: false,
    genders: [
      {text:'Male', value: 'M'},
      {text: 'Female', value: 'F'},
      {text:'Undisclosed', value: 'U'},
    ],
    isValid: true,
    savedDog: '',
    editedItem: {
      Member: {
        mNbr: ''
      },
      id: '',
      microchip: '',
      callName: '',
      registeredName: '',
      dob: '',
      breed: '',
      xBreeds: '',
      gender: '',
      rescue: false,
      deceased: false,
      humanReactive: false,
      dogReactive: false,
      reactiveParking: false,
      active: true,
      feePaid: '',
      hasPaid: false,
      note: '',
      registrations: null
    },
    defaultItem: {
      Member: {
        mNbr: ''
      },
      id: '',
      microchip: '',
      callName: '',
      registeredName: '',
      dob: '',
      breed: '',
      xBreeds: '',
      gender: '',
      rescue: false,
      deceased: false,
      humanReactive: false,
      dogReactive: false,
      reactiveParking: false,
      active: true,
      feePaid: '',
      hasPaid: false,
      note: ''
    },
  }),
  computed: {
    isAdmin() {
      return this.$hasRole(['adm','sys'])
    },
    hasRegs() {
      try
      {
        return this.editedItem.registrations.length > 0
        //return this.editedItem.hasPaid
      } catch (err) {
        return false
      }
    },
    formTitle() {
      return this.dog.id === null ? 'Add Canine' : `Edit ${this.dog.callName}`
    },
    dateKey() {
      let k1 = this.editedItem.dob
      if (this.dog.kNbr) {
        k1 = k1 + 'editedItem.kNbr'
      }
      return k1
    },
    addPending() {
      if (this.mbr.dogs !== 'undefined') {
        for (let idx = this.mbr.dogs.length - 1; idx >= 0; idx--) {
          if (this.mbr.dogs[idx].id == null) {
            return true
          }
        }
      }
      return false
    }
  },
  mounted: function () {
    console.log('DogEdit mounted')
    this.editedItem = Object.assign(this.editedItem, this.dog)
    if (this.editedItem.Member.mNbr === '') {
      if (this.mbr) {
        this.editedItem.Member.mNbr = this.mbr.mNbr
      }
    }
    this.savedDog = Object.assign({}, this.dog)
    console.log(this.editeditem)
//    this.loadRegs(this.dog.id)
  },
  methods: {
    syncFeePaid() {
      console.log('syncFeePaid()')
      if(this.feeIsPaid) {
        this.editedItem.feePaid = new Date().toISOString()
      } else {
        this.editedItem.feePaid = null
      }
    },
    toggleT() {
      this.showTitles = !this.showTitles
      this.showRegs = false
    },
    toggleR() {
      this.showRegs = !this.showRegs
      this.showTitles = false
    },
    dis() {
      return !this.allowOwnerChange
    },
    dob(event) {
      this.editedItem.dob = event
    },
    markPaid() {
      this.editedItem.feePaid = new Date().toISOString()
    },
    markUnPaid() {
      this.editedItem.feePaid = null
    },
    close: function () {
      this.editedItem.kNbr = 'K999999'
      this.editedItem = Object.assign(this.editedItem, this.savedDog)
      this.$emit('endDogEdit', null)
    },
    reset() {
      this.$http.post(this.$remote + '/api/dog', {id: this.editedItem.id, token: localStorage.getItem('token')})
          .then(response => {
            this.$usrStore.token = response.data.token
            this.editedItem = Object.assign(this.editedItem, response.data.dog)
            console.log(response)
          }).catch(reason => {
        alert('Could not refresh the dog data from the server. Please log in again and retry. Server reported: ' + reason)
      })
    },
    save() {

      if (this.dog.id) {
        this.$http.post(this.$remote + '/api/moddog', {dog: this.editedItem, token: localStorage.getItem('token')})
            .then(response => {
              this.$usrStore.token = response.data.token
              console.log(response)
            }).catch(reason => {
          alert(reason.response.data.message)
        })
      } else {
        this.editedItem.memberId = this.mbr.id
        this.editedItem.Member.mNbr = this.mbr.mNbr
        this.$http.post(this.$remote + '/api/newdog', {dog: this.editedItem, token: localStorage.getItem('token')})
            .then(response => {
              localStorage.setItem('token', response.data.token)
              console.log(response)
              if (this.mbr.dogs !== 'undefined') {
                for (let idx = this.mbr.dogs.length - 1; idx >= 0; idx--) {
                  if (this.mbr.dogs[idx].id == null) {
                    this.mbr.dogs.splice(idx, 1);
                  }
                }
                this.mbr.dogs.push(response.data.dog)
                this.$emit('dogAdded', response.data.dog)
              }
            }).catch(reason => {
          alert(reason.response.data.message)
        })
      }
      this.$emit('endDogEdit', this.editedItem)
    },
  }
}
</script>

<style scoped>

</style>
